<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">Allowance calculation (ID: {{ allowance.id }})</h1>
        <div class="status-title" :style="{ 'backgroundColor': allowance.status.color || '#8a8a8a' }">
          {{ allowance.status.name }}
        </div>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Month:</span>
              <span>{{ dateFormat(allowance.month) }}</span>
            </div>
            <div class="info-cards__row-item">
              <span>Drivers:</span>
              <span>{{ allowance.drivers }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Days:</span>
              <span>{{ allowance.days.toLocaleString() }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Amount:</span>
              <span>{{ allowance.amount.toLocaleString() }} TSh</span>
            </div>
          </div>
        </div>
      </div>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__driver><div class="table-default__left">Driver</div></template>
        <template #driver="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'employees-profile', params: { id: row.employee_month.employee.id } }"
              class="table-default__link-border"
            >
              {{ row.employee_month.employee.full_name }}
            </router-link>
          </div>
        </template>
        <template #rate_per_day="{ row }">{{ row.rate_per_day.toLocaleString() }}</template>
        <template #days="{ row }">
          {{ row.days.toLocaleString() }}
        </template>
        <template #amount="{ row }">{{ row.amount.toLocaleString() }} TSh</template>
      </v-client-table>
      <app-cells>
        <app-button
          v-if="allowance.status.code === 'wait' && (is_general_manager || is_safari_supervisor)"
          @click.native="onPatchDriverAllowance({ status: 'approved' })"
          ref="patch"
        >
          Approved
        </app-button>
      </app-cells>
    </template>
  </div>
</template>

<script>
import {
  getEmployeesSafariDriverAllowance,
  getEmployeesSafariDriverAllowanceEmployeesList,
  patchEmployeesSafariDriverAllowance,
} from '@/http'
import { format, parse } from 'date-fns'

export default {
  name: 'SafariAllowanceDetail',
  data() {
    return {
      is_loaded: false,
      allowance: {},
      table_preloader: false,
      table: {
        items: [],
        columns: ['driver', 'rate_per_day', 'days', 'amount'],
        options: {
          headings: {
            driver: 'Driver',
            rate_per_day: 'Rate per day',
            days: 'Days',
            amount: 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_safari_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('safari_supervisor')
    },
  },
  created() {
    this.getAllowanceData()
    this.getDriverAllowanceEmployeesList()
  },
  methods: {
    onPatchDriverAllowance(data) {
      this.$refs.patch.preload = true
      patchEmployeesSafariDriverAllowance(this.$route.params.id, data)
        .finally(() => { this.$refs.patch.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Status changed',
          })
          this.getAllowanceData()
          this.getDriverAllowanceEmployeesList()
        })
    },
    getAllowanceData() {
      getEmployeesSafariDriverAllowance(this.$route.params.id)
        .then(res => {
          this.allowance = res.data
          this.is_loaded = true
        })
    },
    getDriverAllowanceEmployeesList() {
      this.table_preloader = true
      getEmployeesSafariDriverAllowanceEmployeesList(this.$route.params.id)
        .then(res => {
          this.table.items = res.data
          this.table_preloader = false
        })
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'MMM yyyy')
    },
  }
}
</script>
